<template>
	<div>
        <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
        	
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col">
                    <div class="card shadow">
                        <div class="col-md-12 mt-4">
                            <vue-good-table :columns="columns" :rows="allCuentas" :search-options="searchOptions" :pagination-options="paginationOptions" styleClass="vgt-table striped ">
                            </vue-good-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
	@import '~vue-good-table/dist/vue-good-table.css';

    .vgt-global-search {
        border: 0 !important;
        background: none !important;

        .vgt-global-search__input {
            @apply p-0;

            .input__icon {
                position: absolute;
                top: 0;
                right: 15px;
                max-width: 32px;
                left: inherit;
            }

            .vgt-pull-left {
                float: right !important;
            }

            .vgt-input {
                width: 50%;
                background-color: #fff;
                border: 0;
                border-bottom: 1px solid #eaeaea!important;
                border-radius: 0;
                -webkit-box-shadow: none;
                box-shadow: none;
                color: #565656;
                height: 30px;
                max-width: 100%;
                padding: 7px 40px 7px 10px;
                -webkit-transition: all 300ms linear 0s;
                transition: all 300ms linear 0s;

                &:focus {
                    -webkit-box-shadow: none;
                    box-shadow: none;
                    border-color: #b7b7b7;
                }

                @screen sm {
                    width: 70%;
                }
                @screen lg {
                    width: 40%;
                }
            }
        }
    }

    .vgt-table {
        border: 0 !important;
        font-size: 14px !important;

        &.striped tbody tr:nth-of-type(odd) {
            @apply bg-grey-lightest;
        }

        thead th {
            @apply border-b bg-grey-light;
            background: none !important;
        }

        tbody td {
            vertical-align: middle !important;
            border-bottom: 0 !important;
        }
    }

    .vgt-wrap__actions-footer {
        @apply border-0 border-b bg-grey-light;
    }

    .vgt-wrap__footer {
        border: 0 !important;
        background: none !important;
    }
</style>

<script>
    import { VueGoodTable } from 'vue-good-table'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: "Cuentas",
        components: {
            VueGoodTable
        },
        data() {
          return {
                valuePagination: {
                    default: 1
                },
                columns: [{
                    label: 'Identificador',
                    field: 'identificador'
                }, {
                    label: 'Representante',
                    field: 'idrepresentantedesc'
                }, {
                    label: 'Razón Social',
                    field: 'razonsocial',
                }, {
                    label: 'Giro',
                    field: 'giro'
                }, {
                    label: 'Dirección',
                    field: 'direccion'
                }, {
                    label: '',
                    field: 'actions',
                    sortable: false,
                    tdClass: 'vgt-center-align'
                }],
                searchOptions: {
                    enabled: true,
                    placeholder: 'Buscar'
                },
                paginationOptions: {
                    enabled: true,
                    mode: 'records',
                    perPage: 10,
                    position: 'bottom',
                    perPageDropdown: [10, 25, 50, 100],
                    dropdownAllowAll: false,
                    setCurrentPage: 1,
                    nextLabel: 'Siguiente',
                    prevLabel: 'Anterior',
                    rowsPerPageLabel: 'Registros por pág.',
                    ofLabel: 'de',
                    pageLabel: 'pág.',
                    allLabel: 'Todos'
                }
          }
        },
        computed: {
        	...mapGetters('cuentas', { allCuentas: 'all' })
        },
        methods: {
            ...mapActions('cuentas', { getAllCuentas: 'getAll' }),
            getAll() {
                Promise.all[(
                    this.getAllCuentas()
                )]
            }

        },
        mounted() {
            this.getAll()
        }
    }
</script>
